import { $cmsData, settings } from "../common/setting";
import { cr, interact, URLS } from "fire-wind-water";
import { userService } from "../services/user";

class Login {
  $skelem = ".sk-component.REGISTRATION";
  isLogin = false;
  link = "javascript:;";
  regLink = "javascript:;";
  userLink = "javascript:;";
  isNavShow = true;
  isNavFixed = false; // 是否固定导航
  headImgUrl = "";

  constructor() {
    $sk.template.module(this);
  }

  skAfterViewChecked(): void {
    cr.each($cmsData.container, (item: { [label: string]: any }) => {
      cr.each(item, (d) => {
        if (d.type === "REGISTRATION" && !settings.memberFormId) {
          settings.memberFormId = d.historyContent.content.formId;
        }
        if (d.type === "NAV") {
          this.isNavShow =
            d.historyContent.basic.style.type !== "bottomNav"
              ? d.isShow === 1 || d.isShow === 3
              : false;
          if (d.historyContent.style.navType === "1") {
            this.isNavFixed = true;
          }
        }
      });
    });
    // this.isNavShow = settings.isNavShow;
    this.getForm();
  }

  skUserEnd() {
    this.resetLogin();
    this.contact();
  }

  skUserChange() {
    this.resetLogin();
  }

  skLinkEnd() {
    const m = $sk.template.get();
    // 营销建站模版，登录还是跳转登录
    // $sk.goto(m.link, true).subscribe((res) => {
    //   this.link = res;
    //   settings.memberFormUrl = this.link;
    // });
    let link = m.common.memberInfo?.loginUrl[interact.isMobile ? "wap" : "pc"];
    link = URLS.updateSearchParam(
      "backUrl",
      encodeURIComponent(window.location.href),
      link
    );
    $sk.goto(link, true).subscribe((res) => {
      this.link = res;
      settings.memberFormUrl = this.link;
    });

    let regLink =
      m.common.memberInfo?.registerUrl[interact.isMobile ? "wap" : "pc"];
    regLink = URLS.updateSearchParam(
      "backUrl",
      encodeURIComponent(window.location.href),
      regLink
    );
    $sk.goto(regLink, true).subscribe((res) => {
      this.regLink = res;
    });
    $sk
      .goto(
        `${$sk.config.usercenterUrl}index.html?memberSchemaId=${m.common.schemaId}&memberFormId=${settings.memberFormId}&tenantId=${settings.tenantId}#/`,
        true
      )
      .subscribe((res) => {
        this.userLink = res;
      });
  }

  resetLogin() {
    const m = $sk.template.get();
    if (m.user.session) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
  }

  getForm() {
    if (!settings.memberFormId) {
      return false;
    }
    $sk.template.update({
      type: "link",
      data: {
        identity: 3,
        weChatId: 0,
        skObjectType: "cms",
        skObjectId: "",
        meetingInstanceId: "",
        meetingType: "",
        skIsNotLink: 1,
        memberFormId: settings.memberFormId,
      },
    });
  }

  contact() {
    const m = $sk.template.get();
    const n = {
      isTemplate: 1,
      schemaId: m.common.schemaId,
      sess: m.user.session,
      tenantId: m.common.tenantId,
    };
    if (n.sess) {
      userService.contact(n).subscribe((res) => {
        if (res.result === 0) {
          this.headImgUrl = res.content.headImgUrl || "";
        }
      });
    }
  }

  logout() {
    const m = $sk.template.get();
    const n = {
      memberFormId: settings.memberFormId,
      schemaId: m.common.schemaId,
      sess: m.user.session,
      url: window.location.href,
    };
    m.cookie.removeSession();
    this.isLogin = false;
    userService.logout(n).subscribe(() => {
      $sk.template.update({ type: "user" });
      this.getForm();
    });
  }
}

export { Login };
